import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { TransactionDetailsType } from "../../types/genericType";
import { calculateDates } from "../../utils/utils";

type clientTransactionDetailsState = {
  transactionDetails: Array<TransactionDetailsType>;
  timeframe?: string;
  startFilterDate: string;
  endFilterDate: string;
};

const [defaultStart, defaultEnd] = calculateDates("0") ?? ["", ""];

const initialState: clientTransactionDetailsState = {
  transactionDetails: [],
  timeframe: "0",
  startFilterDate: defaultStart,
  endFilterDate: defaultEnd,
};



export const clientTransactionsSlice = createSlice({
  name: "clientTransactionDetailsState",
  initialState,
  reducers: {
    setTransactionsDetailsState: (
      state,
      action: PayloadAction<TransactionDetailsType[]>
    ) => {
      state.transactionDetails = action.payload;
    },
    updateTimeframe: (state, action: PayloadAction<string>) => {
      const values = calculateDates(action.payload);
      state.timeframe = action.payload;
      state.startFilterDate = values?.[0] ?? "";
      state.endFilterDate = values?.[1] ?? "";
    },
    updateDates: (state, action) => {
      state.startFilterDate = action.payload.startDate;
      state.endFilterDate = action.payload.endDate;
    },
  },
});

export const { setTransactionsDetailsState, updateTimeframe, updateDates } =
  clientTransactionsSlice.actions;

export default clientTransactionsSlice.reducer;
